define.alias("ember-composable-helpers/helpers/group-by", "calendar/helpers/group-by");